export enum StatusQueryStatus {
  Open = 'open',
  PartlyOpen = 'partly_open',
  Closed = 'closed',
}
